module.exports = __webpack_public_path__ + "static/fonts/CircularStd-Black.4c87396a.eot";